import { render, staticRenderFns } from "./surveyQuizeCreate.vue?vue&type=template&id=eb7658dc"
import script from "./surveyQuizeCreate.vue?vue&type=script&lang=js"
export * from "./surveyQuizeCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports